/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { FIREFLY_PRO_OFFER_ID_TRIAL_TO_PAID } from "constants/Commerce";

// Adobe Commerce/AOS offer ID for the Firefly Pro plan. Hardcoded to the
// Trial-to-Paid offer for all users; the fireflyProTrialToPaidEnabled
// CurrentUser flag exists but is not consulted here. Shared by
// usePremiumPricing (display price) and useCheckout (purchase) so they
// always quote and charge the same SKU.
export const useOfferId = (): string | null => {
  return FIREFLY_PRO_OFFER_ID_TRIAL_TO_PAID;
};
